import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useCallback, useEffect, useState } from "react";
import type { UseFormReturn } from "react-hook-form";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import type { CreateDataProviderSchema } from "@/lib/schema/data-provider";
import type { ProviderType } from "@/types/dataProvider";
import type { ProviderConfig } from "./provider-config";
import { PROVIDER_CONFIGS, unknownConfig } from "./provider-configs";
interface UseProviderFlowProps {
  selectedType: ProviderType;
  form: UseFormReturn<CreateDataProviderSchema>;
  pingWorkspaceDataProvider: (data: CreateDataProviderSchema) => Promise<any>;
  createWorkspaceDataProvider: (data: CreateDataProviderSchema) => Promise<any>;
  pingingWorkspaceDataProvider: boolean;
  creatingWorkspaceDataProvider: boolean;
}
export const useProviderFlow = t0 => {
  const $ = _c(49);
  const {
    selectedType,
    form,
    pingWorkspaceDataProvider,
    createWorkspaceDataProvider,
    pingingWorkspaceDataProvider,
    creatingWorkspaceDataProvider
  } = t0;
  const {
    workspaceId
  } = useCurrentWorkspace();
  const [currentStep, setCurrentStep] = useState(0);
  const [customSubmission, setCustomSubmission] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [providerData, setProviderData] = useState(t1);
  const config = selectedType ? PROVIDER_CONFIGS[selectedType] : unknownConfig;
  const totalSteps = config.steps.length;
  const isLastStep = currentStep === totalSteps - 1;
  const isSubmitting = customSubmission || pingingWorkspaceDataProvider || creatingWorkspaceDataProvider;
  let t2;
  if ($[1] !== config || $[2] !== form || $[3] !== workspaceId) {
    t2 = () => {
      if (config.onInit) {
        config.onInit(form, workspaceId);
      }
    };
    $[1] = config;
    $[2] = form;
    $[3] = workspaceId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const initFlow = t2;
  let t3;
  if ($[5] !== initFlow) {
    t3 = () => {
      setCurrentStep(0);
      setProviderData({});
      initFlow();
    };
    $[5] = initFlow;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== selectedType) {
    t4 = [selectedType];
    $[7] = selectedType;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== config || $[10] !== form) {
    t5 = () => {
      setCurrentStep(0);
      setProviderData({});
      if (config.onReset) {
        config.onReset(form);
      }
    };
    $[9] = config;
    $[10] = form;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const resetFlow = t5;
  let t6;
  if ($[12] !== config || $[13] !== createWorkspaceDataProvider || $[14] !== currentStep || $[15] !== form || $[16] !== isLastStep || $[17] !== pingWorkspaceDataProvider || $[18] !== resetFlow || $[19] !== workspaceId) {
    t6 = async data => {
      if (isLastStep) {
        if (config.onFinalSubmit) {
          setCustomSubmission(true);
          const result = await config.onFinalSubmit(data, {
            createProvider: createWorkspaceDataProvider,
            form,
            pingProvider: pingWorkspaceDataProvider,
            workspaceId
          });
          setCustomSubmission(false);
          if (result.success) {
            resetFlow();
            return {
              success: true
            };
          }
          return {
            success: false
          };
        }
        setCustomSubmission(true);
        await createWorkspaceDataProvider(data);
        resetFlow();
        setCustomSubmission(false);
        return {
          success: true
        };
      }
      if (config.onStepSubmit) {
        setCustomSubmission(true);
        const result_0 = await config.onStepSubmit(currentStep, data, {
          form,
          pingProvider: pingWorkspaceDataProvider,
          workspaceId
        });
        setCustomSubmission(false);
        if (result_0.success && result_0.shouldAdvance) {
          if (result_0.data) {
            setProviderData(prev => ({
              ...prev,
              ...result_0.data
            }));
          }
          setCurrentStep(_temp);
        }
        return result_0;
      }
      setCurrentStep(_temp2);
      return {
        success: true
      };
    };
    $[12] = config;
    $[13] = createWorkspaceDataProvider;
    $[14] = currentStep;
    $[15] = form;
    $[16] = isLastStep;
    $[17] = pingWorkspaceDataProvider;
    $[18] = resetFlow;
    $[19] = workspaceId;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const handleStepSubmit = t6;
  let t7;
  if ($[21] !== config || $[22] !== currentStep || $[23] !== form || $[24] !== pingWorkspaceDataProvider || $[25] !== workspaceId) {
    t7 = () => {
      if (config?.canSubmitStep) {
        return config.canSubmitStep({
          form,
          pingProvider: pingWorkspaceDataProvider,
          stepIndex: currentStep,
          workspaceId
        });
      }
      return true;
    };
    $[21] = config;
    $[22] = currentStep;
    $[23] = form;
    $[24] = pingWorkspaceDataProvider;
    $[25] = workspaceId;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  const canSubmit = t7;
  let t8;
  if ($[27] !== config || $[28] !== currentStep || $[29] !== isLastStep || $[30] !== isSubmitting || $[31] !== totalSteps) {
    t8 = () => {
      if (config.getSubmitButtonText) {
        return config.getSubmitButtonText(currentStep, totalSteps, isSubmitting);
      }
      return isSubmitting ? "Saving..." : isLastStep ? "Save" : "Next";
    };
    $[27] = config;
    $[28] = currentStep;
    $[29] = isLastStep;
    $[30] = isSubmitting;
    $[31] = totalSteps;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  const getSubmitButtonText = t8;
  let t9;
  if ($[33] !== canSubmit) {
    t9 = canSubmit();
    $[33] = canSubmit;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const t10 = config.steps;
  let t11;
  if ($[35] !== getSubmitButtonText) {
    t11 = getSubmitButtonText();
    $[35] = getSubmitButtonText;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== config.steps || $[38] !== currentStep || $[39] !== handleStepSubmit || $[40] !== initFlow || $[41] !== isLastStep || $[42] !== isSubmitting || $[43] !== providerData || $[44] !== resetFlow || $[45] !== t11 || $[46] !== t9 || $[47] !== totalSteps) {
    t12 = {
      canSubmit: t9,
      currentStep,
      goToStep: setCurrentStep,
      handleStepSubmit,
      initFlow,
      isLastStep,
      isSubmitting,
      providerData,
      resetFlow,
      steps: t10,
      submitButtonText: t11,
      totalSteps
    };
    $[37] = config.steps;
    $[38] = currentStep;
    $[39] = handleStepSubmit;
    $[40] = initFlow;
    $[41] = isLastStep;
    $[42] = isSubmitting;
    $[43] = providerData;
    $[44] = resetFlow;
    $[45] = t11;
    $[46] = t9;
    $[47] = totalSteps;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  return t12;
};
function _temp(prev_0) {
  return prev_0 + 1;
}
function _temp2(prev_1) {
  return prev_1 + 1;
}